import {useMemo} from "react";
import {css, cx} from "@panda/css";

import SlickSlider from "@pg-mono/slick-slider";

import {slickSliderPandaStyle} from "../../../app/styles/slick_slider_pandacss";
import {getAdjustedSliderSettings} from "../../../app/utils/get_adjusted_slider_settings";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {OfferBoxPlaceholder} from "../../atoms/OfferBoxPlaceholder";
import {OfferBoxWithOfferDetailsAction} from "../../atoms/OfferBoxWithOfferDetailsAction";
import {carouselSliderSettings} from "../../constants/carousel_slider_settings";
import {IOfferBox} from "../offer_box/OfferBox";
import {OfferModal} from "../offer_modal/OfferModal";

interface IProps {
    offerIds: number[];
    gtmMeta: IOfferBox["gtmMeta"];
}

export const RelatedOfferCarouselWithModal = (props: IProps) => {
    const {offerIds} = props;
    const {data, isUninitialized, isSuccess, isError, isLoading, isFetching} = useGetOfferListQuery(
        {
            page: 1,
            page_size: 20,
            include_offer: offerIds
        },
        {
            skip: !offerIds.length || offerIds.length === 0
        }
    );

    const itemCount = data?.results.length ?? 0;
    const adjustedSliderSettings = useMemo(() => getAdjustedSliderSettings(carouselSliderSettings, itemCount), [itemCount]);

    return (
        <div className={cx(slickSliderPandaStyle, carouselWrapperStyle)}>
            <SlickSlider {...adjustedSliderSettings}>
                {!!data && data.results.length > 0
                    ? data.results.map((offer, index) => {
                          return <OfferBoxWithOfferDetailsAction key={offer.id} offer={offer} index={index} gtmMeta={props.gtmMeta} />;
                      })
                    : Array.from({length: 4}).map((_, index) => {
                          return <OfferBoxPlaceholder key={index} />;
                      })}
            </SlickSlider>

            <OfferModal
                modalName="mainOfferModal"
                offersQuery={{
                    data: data?.results || [],
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isError,
                    isLoading,
                    count: data?.count || 0,
                    page: data?.page || 1,
                    pageSize: data?.page_size || 20,
                    requestState: getRequestStateFromRtkQuery({isFetching, isSuccess, isError, isLoading})
                }}
            />
        </div>
    );
};

const carouselWrapperStyle = css({
    "& .slick-list": {
        paddingBottom: 3,

        "& .slick-track": {
            "& .slick-slide:not(:first-of-type)": {
                padding: "0 1.6rem"
            }
        }
    },
    xs: {
        "& .slick-list .slick-track .slick-slide": {
            padding: "0 1.6rem"
        }
    },
    smDown: {
        "& .slick-list .slick-track .slick-slide": {
            maxWidth: "330px"
        }
    },
    "& .slick-next": {
        width: "20px",
        "&::before": {
            right: "-1rem",
            transform: "translate(0, -20px)"
        }
    },
    "& .slick-prev": {
        width: "20px",
        "&::before": {
            left: "-1rem",
            transform: "translate(0, -20px)"
        }
    }
});
import {useMemo} from "react";
import {css, cx} from "@panda/css";

import SlickSlider from "@pg-mono/slick-slider";

import {slickSliderPandaStyle} from "../../../app/styles/slick_slider_pandacss";
import {getAdjustedSliderSettings} from "../../../app/utils/get_adjusted_slider_settings";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {OfferBoxPlaceholder} from "../../atoms/OfferBoxPlaceholder";
import {OfferBoxWithOfferDetailsAction} from "../../atoms/OfferBoxWithOfferDetailsAction";
import {carouselSliderSettings} from "../../constants/carousel_slider_settings";
import {IOfferBox} from "../offer_box/OfferBox";
import {OfferModal} from "../offer_modal/OfferModal";

interface IProps {
    offerIds: number[];
    gtmMeta: IOfferBox["gtmMeta"];
}

export const RelatedOfferCarouselWithModal = (props: IProps) => {
    const {offerIds} = props;
    const {data, isUninitialized, isSuccess, isError, isLoading, isFetching} = useGetOfferListQuery(
        {
            page: 1,
            page_size: 20,
            include_offer: offerIds
        },
        {
            skip: !offerIds.length || offerIds.length === 0
        }
    );

    const itemCount = data?.results.length ?? 0;
    const adjustedSliderSettings = useMemo(() => getAdjustedSliderSettings(carouselSliderSettings, itemCount), [itemCount]);

    return (
        <div className={cx(slickSliderPandaStyle, carouselWrapperStyle)}>
            <SlickSlider {...adjustedSliderSettings}>
                {!!data && data.results.length > 0
                    ? data.results.map((offer, index) => {
                          return <OfferBoxWithOfferDetailsAction key={offer.id} offer={offer} index={index} gtmMeta={props.gtmMeta} />;
                      })
                    : Array.from({length: 4}).map((_, index) => {
                          return <OfferBoxPlaceholder key={index} />;
                      })}
            </SlickSlider>

            <OfferModal
                modalName="mainOfferModal"
                offersQuery={{
                    data: data?.results || [],
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isError,
                    isLoading,
                    count: data?.count || 0,
                    page: data?.page || 1,
                    pageSize: data?.page_size || 20,
                    requestState: getRequestStateFromRtkQuery({isFetching, isSuccess, isError, isLoading})
                }}
            />
        </div>
    );
};

const carouselWrapperStyle = css({
    "& .slick-list": {
        paddingBottom: 3,

        "& .slick-track": {
            "& .slick-slide:not(:first-of-type)": {
                padding: "0 1.6rem"
            }
        }
    },
    xs: {
        "& .slick-list .slick-track .slick-slide": {
            padding: "0 1.6rem"
        }
    },
    smDown: {
        "& .slick-list .slick-track .slick-slide": {
            maxWidth: "330px"
        }
    },
    "& .slick-next": {
        width: "20px",
        "&::before": {
            right: "-1rem",
            transform: "translate(0, -20px)"
        }
    },
    "& .slick-prev": {
        width: "20px",
        "&::before": {
            left: "-1rem",
            transform: "translate(0, -20px)"
        }
    }
});
